module.exports = __webpack_public_path__ + "static/IMG_8121_mobile-f76b275d304f9c8ec229ac2fcff09eb8.jpg";